import { useEffect } from 'react';

let lastActive: number = Date.now();

export { initActivityMonitor, isUserIdle, removeActivityMonitor };

const IDLE_PERIOD = 25 * 60 * 1000;
export const EVENTS = [
    'mousemove',
    'keydown',
    'wheel',
    'DOMMouseScroll',
    'mousewheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'MSPointerDown',
    'MSPointerMove',
    'visibilitychange',
    'focus'
] as const;

function eventHandler() {
    lastActive = Date.now();
}

export function useMonitorActivity() {
    useEffect(() => {
        initActivityMonitor();
        return () => {
            removeActivityMonitor();
        };
    }, []);
}

function initActivityMonitor() {
    if (typeof window == 'undefined') {
        return;
    }

    EVENTS.forEach(evt => {
        window.addEventListener(evt, eventHandler);
    });
}

function removeActivityMonitor() {
    EVENTS.forEach(evt => {
        window.removeEventListener(evt, eventHandler);
    });
}

function isUserIdle() {
    return Date.now() > lastActive + IDLE_PERIOD;
}
